import React from "react";

import { Grid } from "@mui/material";

import useStyles from "./suspenseLoader.style";
import BrandLogo from "../../container/SportsBookNode/BrandLogo";

function SuspenseLoader() {
  const classes = useStyles();
  return (
    <Grid className={classes?.container}>
      <Grid className={classes.loaderAndImg}>
        <BrandLogo />
        <div className={classes.loader}></div>
      </Grid>
    </Grid>
  );
}

export default SuspenseLoader;
